import React from 'react'
import {
    Box,
    Button,
} from '@material-ui/core'
import { useSelector } from 'react-redux'
import { juridicalPersons } from '../../../store/slices'
import { SideBar } from '../../../components/side-bar'
import { navLinksOrganization } from '../../../services'
import { Link } from 'react-router-dom'
import { DataTable } from '../../../components/dataTable'
import { ROUTES } from '../../../constants'
import { IJuridicalPerson } from '../../../store/types'
import { FetchCollectionParams, FetchCreatedAtParams } from '../../../services/_common'

export function JuridicalPersonsPage(): JSX.Element {

    const fetchStatus = useSelector(juridicalPersons.selectors.fetchStatus)
    const totalItems = useSelector(juridicalPersons.selectors.totalItems)

    return (
        <Box display="flex">
            <SideBar navLinks={navLinksOrganization}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    component={Link}
                    to={ROUTES.ORGANIZATION_JURIDICAL_PERSONS_CREATE}
                >
                    Создать
                </Button>
            </SideBar>
            <DataTable<IJuridicalPerson, FetchCreatedAtParams & FetchCollectionParams>
                title={'Юр. лица'}
                urlPathEdit={'/organization/juridical-persons/edit'}
                fetchProps={{
                    page: 1,
                    perPage: 20,
                }}
                fetchAction={juridicalPersons.actions.fetch}
                deleteAction={juridicalPersons.actions.remove}
                selector={juridicalPersons.selectors.selectAll}
                mappingFunction={(juridicalPerson) => ({
                    id: juridicalPerson.id,
                    name: juridicalPerson.name,
                })}
                columns={[
                    { field: 'id', headerName: 'ID', flex: 1 },
                    { field: 'name', headerName: 'Название', flex: 1 },
                ]}
                loading={fetchStatus.isFetching}
                rowCount={totalItems}
            >
            </DataTable>
        </Box>
    )
}